import Vue from 'vue'
import store from '~/js/store'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

const topbasket = new Vue({
    el: '.top-basket-js',
    data: {
      url: '/bitrix/services/main/ajax.php'
    },
    computed: {
        count () {
            return store.state.basketCount;
        }
    },
    mounted() {
      this.axios.get(this.url, {
        params: {
          c: 'its:basketcounter',
          action: 'getCount',
          mode: 'class'
        }
      })
      .then((response) => {
          if (response.data.status === 'success') {
            store.commit('basketCountInit', response.data.data.count);
          }
      })
      .catch(e => {
          this.errors.push(e)
      });
    }
});
